"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Game = void 0;
class Game {
    constructor(name) {
        this._name = name;
    }
    static fromName(name, strict = true) {
        const item = Game._values.find((it) => it._name === name);
        if (item) {
            return item;
        }
        if (strict) {
            throw new Error(`Invalid game: ${name}`);
        }
    }
    static fromRaw(raw, strict = true) {
        return Game.fromName(raw, strict);
    }
    toString() {
        return this._name;
    }
}
exports.Game = Game;
Game.Taiko = new Game('Taiko');
Game.Jube = new Game('Jube');
Game._values = [Game.Taiko, Game.Jube];
